import { render, staticRenderFns } from "./AttendanceConfigDialog.vue?vue&type=template&id=675083d6&scoped=true"
import script from "./AttendanceConfigDialog.vue?vue&type=script&lang=js"
export * from "./AttendanceConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./AttendanceConfigDialog.vue?vue&type=style&index=0&id=675083d6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675083d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('675083d6')) {
      api.createRecord('675083d6', component.options)
    } else {
      api.reload('675083d6', component.options)
    }
    module.hot.accept("./AttendanceConfigDialog.vue?vue&type=template&id=675083d6&scoped=true", function () {
      api.rerender('675083d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/attendance_v3/components/dialog/AttendanceConfigDialog.vue"
export default component.exports